// @flow
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import CompanyDetail from '../components/AdminCompanyList/CompanyDetail'
import * as actions from '../actions'

import type {MapStateToProps, MapDispatchToProps} from 'react-redux'
import type {State, Action} from 'modules/Common/types'
import type {RouterHistory, Match} from 'react-router'
import type {AdminState} from '../types/index'

export type OwnProps = {
  history: RouterHistory,
  location: {
    pathname: string
  },
  match: ?Match
};

export type StateProps = {
  accountManagers: $PropertyType<AdminState, 'accountManagers'>,
  isLoadingAccountManagers: $PropertyType<AdminState, 'isLoadingAccountManagers'>,
  companies: $PropertyType<AdminState, 'companies'>,
  error: $PropertyType<AdminState, 'error'>,
  isInvitingAM: $PropertyType<AdminState, 'isInvitingAM'>,
  isLoadingCompaniesSuggestion: $PropertyType<AdminState, 'isLoadingCompaniesSuggestion'>,
  companiesSuggestion: $PropertyType<AdminState, 'companiesSuggestion'>
};

export type DispatchProps = {
  getAccountManagers: $PropertyType<typeof actions, 'getAccountManagers'>,
  getCompanies: $PropertyType<typeof actions, 'getCompanies'>,
  addOrUpdateAM: $PropertyType<typeof actions, 'addOrUpdateAM'>,
  getCompaniesSuggestion: $PropertyType<typeof actions, 'getCompaniesSuggestion'>
};

const mapStateToProps: MapStateToProps<State, OwnProps, StateProps> = (state: State) => {
  return {
    accountManagers: state.admin.accountManagers,
    isLoadingAccountManagers: state.admin.isLoadingAccountManagers,
    companies: state.admin.companies,
    error: state.admin.error,
    isInvitingAM: state.admin.isInvitingAM,
    isLoadingCompaniesSuggestion: state.admin.isLoadingCompaniesSuggestion,
    companiesSuggestion: state.admin.companiesSuggestion
  }
}
const mapDispatchToProps: MapDispatchToProps<Action<*>, OwnProps, DispatchProps> = dispatch => bindActionCreators({...actions}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetail)
